export default __webpack_public_path__ + "static/media/Sorcerer's Robe of Prestige.f4abc1f0.jpg";